(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-accordion"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function() {
  const accordions = document.querySelectorAll(".accordion-list-item");

  accordions.forEach(item => {
    const title = item.querySelector(".accordion-title");
    const desc = item.querySelector(".accordion-desc");

    title.addEventListener("click", function() {
      // Close other open accordions if you want only one open at a time
      accordions.forEach(i => {
        if (i !== item) {
          i.classList.remove("open");
          i.querySelector(".accordion-desc").style.display = "none";
        }
      });

      // Toggle this one
      item.classList.toggle("open");
      if (item.classList.contains("open")) {
        desc.style.display = "block";
      } else {
        desc.style.display = "none";
      }
    });
  });
});



  } catch(e) { console.error(e); }
})();
})();
